<template>
  <div class="form-item">
    <p class="form-item__title">
      {{info.name}}
    </p>
    <div 
        class="form-row"
        v-for="(order, index) in info.orders"
        :key="index">
        <p class="form-item__col">{{order.name}}</p>
        <p class="form-item__col">{{order.quantity}}</p>
        <div class="form-item__col input-block" v-if="index == 1">
            <span @click="minus()">-</span>
            <input @change="changeQuantity($event)" type="number" value="0" v-model="quantity" />
            <span @click="plus()">+</span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["info", "name", "collectionID"],
  data: () => ({
      productId: '',
      productName: '',
      comment: '',
      offerId: '',
      offerName: '',
      quantity: 0

      
  }),
  methods: {
   plus(){
       this.quantity++;
       this.localStorageUpdate()
   },
   minus(){
       if(this.quantity > 0){
           this.quantity--;
           this.localStorageUpdate()
       }else{
           this.quantity = 0;
           this.localStorageUpdate()
       }
   },
   changeQuantity(event){
     if(event.target.value > 0){
       this.quantity = event.target.value;
     }else{
       this.quantity = 0;
     }
     this.localStorageUpdate()
   },
   localStorageUpdate(){
    let miniCart = this.$localStorageGet('miniCart');
    let data = {
        productId: this.productId,
        collectionID: this.collectionID,
        productName: this.productName,
        comment: this.comment,
        offers: [
            {
                offerId: this.offerId,
                offerName: this.offerName,
                quantity: this.quantity
            }
        ]
    }
    if(Object.keys(miniCart.baskets).length == 0){
        miniCart.baskets.push(data);
        this.$localStorageSet('miniCart', miniCart);
    }else{
        this.updateMiniCart(miniCart, data)
    }
   },
    updateMiniCart(miniCart, cartItem){
        let currentProduct =  miniCart.baskets.find(x => x.productId == cartItem.productId)
        
        

        // Если в корзине нет такого товара
        if(!currentProduct){
            miniCart.baskets.push(cartItem);
        }else{

            let currentcartItem = currentProduct.offers.find(x => x.offerId == this.offerId )

            if(!currentcartItem){
                currentProduct.offers.push(cartItem.offers[0])
            }else{
                currentcartItem.quantity = this.quantity;
                if(currentcartItem.quantity == 0){
                    let index = currentProduct.offers.indexOf(currentcartItem);
                    currentProduct.offers.splice(index, 1);
                }
            }
        }
        this.$localStorageSet('miniCart', miniCart);
    },
  },
  created(){
      this.productId = this.$route.params.element;
      this.productName = this.name;
      this.offerId = this.info.id;
      this.offerName = this.info.name;
      this.colorTitle = this.info.prop.color.title;
      this.comment = '';
      let miniCart = this.$localStorageGet('miniCart');
      let currentProduct =  miniCart.baskets.find(x => x.productId == this.productId)

      if(currentProduct){
          let currentcartItem = currentProduct.offers.find(x => x.offerId == this.offerId )
          if(currentcartItem){
              this.quantity = currentcartItem.quantity
          }else{
              this.quantity = 0;
          }
      }else{
          this.quantity = 0;
      }
  }
};
</script>
<style lang="scss" scoped>
.form-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  .form-item__title {
    width: 100%;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .form-row {
    width: 100%;
    display: flex;
    margin: 0;
    flex-wrap: nowrap;
    margin-bottom: 10px;
    .form-item__col {
      width: 32%;
      min-height: 20px;
      font-size: 12px;
      &:first-child {
        width: 36%;
      }
    }
    .input-block {
      height: auto;
      align-items: center;
      justify-content: center;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #dcdcdc;
      }
      input {
        width: 50px;
      }
    }
  }
}
</style>